<template>
  <div v-if="show" class="slide-container">
    <el-carousel
      ref="carousel"
      :autoplay="carouselAutoplay"
      :interval="3000"
      :arrow="arrow"
      :indicator-position="indicatorPosition"
      :height="carouselHeight + 'px'"
      @change="handleCarouselChange">
      <el-carousel-item class="slide" v-for="(element,index) in value.items"  :key="index">
        <div v-if="element.target_url && !isVideoItem(element)" class="slide-item">
          <i class="middle_i" ></i>
          <a target="_blank" :href="element.target_url.startsWith('http') ? element.target_url : 'http://' + element.target_url.trim()">
            <img ref="bannerHeight" @load="updateCarouselHeight(index)" :src="getFilePath(element.resource_key)">
          </a>
          <p v-html="element.description"></p>
        </div>
        <div v-else class="slide-item">
          <i class="middle_i" ></i>
          <a v-if="!isVideoItem(element)">
            <img ref="bannerHeight" @load="updateCarouselHeight(index)" :src="getFilePath(element.resource_key)">
          </a>
          <video
            v-else
            ref="bannerHeight"
            class="slide-video"
            :controls="!hideVideoControls"
            :loop="shouldLoopVideo(element)"
            muted
            playsinline
            webkit-playsinline
            :src="getFilePath(element.resource_key)"
            @loadedmetadata="updateCarouselHeight(index)"
            @ended="handleVideoEnded"
          ></video>
          <p v-html="element.description"></p>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { getFilePath } from '@/utils/qiniu'

export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    hiddenIndicator: {
      type: Boolean,
      default: false
    },
    slideArrow: {
      type: String,
      default: 'hover'
    },
    hideVideoControls: {
      type: Boolean,
      default: false
    },
    loopSingleVideo: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: true,
      activeIndex: 0,
      carouselAutoplay: true,
      carouselHeight: 300
    }
  },
  computed: {
    indicatorPosition () {
      if (this.hiddenIndicator) {
        return 'none'
      }
      if (this.value?.items?.length < 2) {
        return 'none'
      } else {
        return 'outside'
      }
    },
    arrow () {
      if (this.value?.items?.length < 2) {
        return 'never'
      }
      return this.slideArrow
    }
  },
  created () {
    window.addEventListener('resize', this.initCarouselHeight)
  },
  mounted () {
    this.initCarouselHeight()
    this.$nextTick(() => {
      this.handleCarouselChange(0)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.initCarouselHeight)
  },
  methods: {
    getFilePath (key) {
      return getFilePath(key)
    },
    isVideoItem (item) {
      return item?.resource_type === 'video'
    },
    shouldLoopVideo (item) {
      return this.loopSingleVideo && this.value?.items?.length === 1 && this.isVideoItem(item)
    },
    async initCarouselHeight () {
      this.$nextTick(() => {
        if (this.$refs.bannerHeight?.length > 0) {
          this.carouselHeight = this.$refs.bannerHeight[0].height || this.$refs.bannerHeight[0].offsetHeight
        }
      })
    },
    updateCarouselHeight (index) {
      const media = this.$refs.bannerHeight?.[index]
      if (!media) {
        return
      }
      const height = media.height || media.offsetHeight
      if (height > this.carouselHeight) {
        this.carouselHeight = height
      }
    },
    handleCarouselChange (index) {
      this.activeIndex = index
      this.updateCarouselHeight(index)
      this.pauseAllVideos()
      if (!this.isVideoItem(this.value?.items?.[index])) {
        this.carouselAutoplay = true
        return
      }
      this.carouselAutoplay = false
      this.$nextTick(() => {
        const video = this.$refs.bannerHeight?.[index]
        if (!video) {
          return
        }
        video.currentTime = 0
        const playPromise = video.play()
        if (playPromise?.catch) {
          playPromise.catch(() => {
            this.carouselAutoplay = true
          })
        }
      })
    },
    pauseAllVideos () {
      const mediaList = this.$refs.bannerHeight || []
      mediaList.forEach(media => {
        if (media?.tagName === 'VIDEO') {
          media.pause()
        }
      })
    },
    handleVideoEnded () {
      this.carouselAutoplay = true
      if (this.value?.items?.length > 1) {
        this.$nextTick(() => {
          this.$refs.carousel?.next()
        })
      }
    }
  },
  watch: {
    value: {
      handler () {
        this.show = false
        this.$nextTick(() => {
          this.show = true
          this.initCarouselHeight()
          this.handleCarouselChange(0)
        })
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-container {
  ::v-deep {
    .el-carousel__container {
      .slide-item {
        vertical-align: middle;
        text-align: center;

        img,
        video {
          vertical-align: middle;
          width: 980px;
        }

        video {
          max-width: 100%;
          background: #000;
        }

        p {
          position: absolute;
          left: 50px;
          top: 135px;
          right: 50px;
          font-size: 30px;
          color: white;
        }
      }

      .el-carousel__item {
        display: flex;
        align-items: center;
      }
    }

    .el-carousel__indicators--outside button {
      background-color: #8a8b8d;
    }

    .el-carousel__indicators {
      padding-top: 30px;

      .el-carousel__indicator {
        padding: 0 6px;
      }

      .el-carousel__button {
        width: 10px;
        height: 10px;
        border-radius: 50%;
      }
    }
  }
}
</style>
